import { Heart } from "lucide-react";

const PersonalTouch = () => {
  return (
    <section className="py-12 md:py-16 bg-primary/5">
      <div className="container">
        <div className="max-w-2xl mx-auto">
          <div className="bg-background rounded-lg p-6 md:p-8 border-2 border-primary/20 relative overflow-hidden">
            {/* Decorative element */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-warm opacity-10 rounded-full blur-3xl" />
            
            <div className="relative">
              <div className="flex items-center gap-2 mb-4">
                <Heart className="h-5 w-5 text-primary fill-primary" />
                <span className="text-sm font-semibold text-primary uppercase tracking-wide">
                  P.S.
                </span>
              </div>

              <p className="text-base md:text-lg leading-relaxed mb-4">
                Quer começar hoje com variedade? Experimente a{" "}
                <strong className="text-primary">Receita 8 — é minha favorita</strong> do e-book.
              </p>
              
              <p className="text-muted-foreground">
                É prática, rende bem e fica pronta rapidinho. Depois me conta como ficou! 😋
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PersonalTouch;
